import React from "react";
import styles from "./ImagesList.module.css";
import ImageCard from "./components/ImageCard";
import {
  useAppDispatch,
  useAppSelector,
} from "../../../../../store/common/hooks";
import { deleteImage, fetchImages } from "../../../../../store/images.slice";
import { ImageDataModel } from "../../../../../api/responsePayload/ImagesResponse";

interface ImagesListProps {}

const ImagesList: React.FC<ImagesListProps> = ({}) => {
  const dispatch = useAppDispatch();
  const imageList = useAppSelector((s) => s.images.items);

  const handleDeleteImage = async (imageId: number) => {
    if (window.confirm("Are you sure you want to delete this image?")) {
      await dispatch(deleteImage(imageId));
      await dispatch(fetchImages());
    }
  };

  return (
    <div className={styles["question-group-scroll-container"]}>
      {imageList.map((value: ImageDataModel) => (
        <ImageCard
          key={value.id}
          imageData={value}
          onDeleteImageClicked={handleDeleteImage}
        />
      ))}
    </div>
  );
};

export default ImagesList;
